"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var modal_video_1 = require("./modal-video");
var eventsHelper_1 = require("../utils/eventsHelper");
var typeHelper_1 = require("../utils/typeHelper");
var Modal = /** @class */ (function () {
    function Modal(rootElement) {
        var that = this;
        this.rootElement = rootElement;
        that.addEventListeners();
        eventsHelper_1.default.live('.js-modal-trigger', eventsHelper_1.default.clickOrTouchEvent, function (event, clickedElement) {
            var _a;
            event.preventDefault();
            // If target is toggle hidden trigger element
            if (clickedElement) {
                var targetModal = (_a = clickedElement.dataset.target) !== null && _a !== void 0 ? _a : '#' + clickedElement.closest('.is-open').id;
                that.toggleModal(targetModal);
                return;
            }
        }, rootElement);
        // Click outside
        eventsHelper_1.default.live('.c-modal.is-open', eventsHelper_1.default.clickOrTouchEvent, function (event, clickedElement) {
            var _a;
            // If target is toggle hidden trigger element
            if (clickedElement) {
                if (event.target.id) {
                    var targetModal = document.querySelector('#' + event.target.id);
                    if (targetModal) {
                        var closableString = (_a = targetModal === null || targetModal === void 0 ? void 0 : targetModal.dataset) === null || _a === void 0 ? void 0 : _a.closable;
                        var closable = closableString ? JSON.parse(closableString) : true;
                        if (closable) {
                            that.toggleModal(targetModal, false);
                        }
                    }
                }
                return;
            }
        }, rootElement);
    }
    Modal.prototype.closeModals = function () {
        var _this = this;
        var modals = this.rootElement.querySelectorAll('.c-modal.is-open');
        modals.forEach(function (modal) {
            var _a;
            var closableString = (_a = modal === null || modal === void 0 ? void 0 : modal.dataset) === null || _a === void 0 ? void 0 : _a.closable;
            var closable = closableString ? JSON.parse(closableString) : true;
            if (closable) {
                _this.toggleModal(modal, false);
            }
        });
    };
    Modal.prototype.toggleModal = function (targetModal, open) {
        if (open === void 0) { open = null; }
        var modal = typeHelper_1.default.isString(targetModal) ? this.rootElement.querySelector(targetModal) : targetModal;
        if (modal) {
            var openModal = !modal.classList.contains('is-open');
            // Override open if argument is passed for open
            if (open != null) {
                openModal = open;
            }
            if (!modal)
                return;
            if (openModal) {
                modal.classList.add('is-open');
            }
            else {
                modal.classList.remove('is-open');
                if (modal.classList.contains('c-video-modal')) {
                    modal_video_1.default.closeVideo();
                }
            }
        }
    };
    Modal.prototype.addEventListeners = function () {
        var that = this;
        window.addEventListener('openUnityModal', function (event) {
            that.toggleModal(event.detail.targetModal, true);
        });
        window.addEventListener('toggleUnityModal', function (event) {
            that.toggleModal(event.detail.targetModal);
        });
        window.addEventListener('closeUnityModal', function (event) {
            that.toggleModal(event.detail.targetModal, false);
        });
        // Fallback for shadow dom to set event on document or shadow dom root element
        that.rootElement.addEventListener('openUnityModal', function (event) {
            that.toggleModal(event.detail.targetModal, true);
        });
        that.rootElement.addEventListener('toggleUnityModal', function (event) {
            that.toggleModal(event.detail.targetModal);
        });
        that.rootElement.addEventListener('closeUnityModal', function (event) {
            that.toggleModal(event.detail.targetModal, false);
        });
        // Trigger on Escape key
        that.rootElement.addEventListener('keydown', function (event) {
            if (event.key === "Escape") {
                that.closeModals();
            }
        });
    };
    return Modal;
}());
exports.default = Modal;
